import React, { useMemo, useState } from "react";
import CustomSelect from "../../globalcontrols/customselect/customselect";
import "./css/kakaoCategoryPie.css";

const COLORS = [
  "#a34674", "#6f4029", "#e096bc", "#cb7b45", "#725a8a",
  "#d9a441", "#4f7f78", "#bb5c62", "#7890b0", "#8b7668",
];
const EMPTY_CATEGORIES = [];

const money = (value) => `$${Number(value || 0).toLocaleString("es-CL", { maximumFractionDigits: 0 })}`;

function KakaoCategoryPie({
  data,
  error,
  loading,
  locations,
  selectedLocation,
  setSelectedLocation,
}) {
  const [relative, setRelative] = useState(true);
  const [activeCategory, setActiveCategory] = useState(null);
  const categories = data?.categories || EMPTY_CATEGORIES;
  const gradient = useMemo(() => {
    let start = 0;
    const stops = categories.map((item, index) => {
      const end = start + Number(item.share || 0);
      const stop = `${COLORS[index % COLORS.length]} ${start}% ${end}%`;
      start = end;
      return stop;
    });
    return stops.length ? `conic-gradient(${stops.join(", ")})` : "#eee8e5";
  }, [categories]);

  return (
    <section className="embedded-dashboard-chart kakao-category-chart" aria-labelledby="kakao-category-title">
      <div className="card-heading kakao-category-heading">
        <div>
          <p className="card-kicker">Mix de productos</p>
          <h2 id="kakao-category-title">Ventas KAKAO por categoría</h2>
          <p>Participación según el ingreso bruto de los productos vendidos.</p>
        </div>
        <div className="kakao-category-controls">
          <div className="kakao-category-mode">
            <span>Absoluto</span>
            <button
              type="button"
              role="switch"
              aria-checked={relative}
              aria-label="Cambiar entre valores absolutos y relativos"
              onClick={() => setRelative((current) => !current)}
            >
              <span />
            </button>
            <span>Relativo</span>
          </div>
          <div className="kakao-category-location">
            <CustomSelect
              label="Ubicación"
              options={locations}
              selectedValue={selectedLocation}
              onChange={setSelectedLocation}
              labelExtractor={(item) => item.name}
              valueExtractor={(item) => item.id.toString()}
            />
          </div>
        </div>
      </div>

      {error ? <div className="dashboard-alert" role="alert">{error}</div> : null}
      {loading ? <div className="dashboard-loading" role="status">Agrupando categorías…</div> : (
        categories.length ? (
          <div className="kakao-category-layout" onMouseLeave={() => setActiveCategory(null)}>
            <div
              className="kakao-category-pie"
              style={{ background: gradient }}
              role="img"
              aria-label={categories.map((item) => `${item.category}: ${item.share.toFixed(1)}%`).join(", ")}
            >
              <div>
                <strong>{relative ? "100%" : money(data?.total_revenue)}</strong>
                <span>{relative ? "Participación total" : "Ingreso bruto"}</span>
              </div>
            </div>
            <div className="kakao-category-legend">
              {categories.map((item, index) => (
                <article
                  key={item.category}
                  tabIndex="0"
                  className={activeCategory?.category === item.category ? "is-active" : ""}
                  onMouseEnter={() => setActiveCategory(item)}
                  onFocus={() => setActiveCategory(item)}
                >
                  <span className="kakao-category-swatch" style={{ background: COLORS[index % COLORS.length] }} />
                  <div><strong>{item.category}</strong><small>{item.units.toLocaleString("es-CL")} unidades</small></div>
                  <div className="kakao-category-value">
                    <strong>{relative ? `${item.share.toFixed(1)}%` : money(item.revenue)}</strong>
                    <small>{relative ? money(item.revenue) : `${item.share.toFixed(1)}% del total`}</small>
                  </div>
                </article>
              ))}
            </div>
            {activeCategory ? (
              <aside className="chart-product-popover kakao-category-popover">
                <header><strong>{activeCategory.category}</strong><span>Productos</span></header>
                <div>
                  {(activeCategory.products || []).length ? activeCategory.products.map((product) => (
                    <article key={product.code}>
                      <span>
                        <strong>{product.product}</strong>
                        <small>{product.units.toLocaleString("es-CL")} unidades · {money(product.revenue)}</small>
                      </span>
                      <strong>{relative
                        ? `${activeCategory.revenue ? ((product.revenue / activeCategory.revenue) * 100).toFixed(1) : "0.0"}%`
                        : money(product.revenue)}
                      </strong>
                    </article>
                  )) : <p>Sin productos asociados.</p>}
                </div>
              </aside>
            ) : null}
          </div>
        ) : <div className="empty-state">No hay ventas categorizadas en este periodo.</div>
      )}
    </section>
  );
}

export default KakaoCategoryPie;
